export const practice = {
  defaultTitle: "Üben",
  cancel: "Abbrechen",
  progressAria: "Fortschritt in dieser Runde",
  speakAria: "Wort vorlesen",
  speakSolutionAria: "Lösung vorlesen",
  answerAria: "Deine Antwort",
  check: "Prüfen",
  correct: "Richtig",
  almost: (canonical: string) => `Fast! Richtig ist: ${canonical}`,
  solutionIs: "Richtig ist:",
  next: "Weiter",
  saving: "Deine Antworten werden gespeichert …",
  saveFailed: "Deine Antworten sind noch nicht gespeichert. Prüf die Verbindung und versuch es nochmals.",
  retry: "Nochmals senden",
  leaveUnsaved: "Ohne Speichern beenden",
  roundDone: "Runde fertig",
  /** The round waits on the device and goes out by itself (issue #118). */
  queued: "Deine Antworten sind auf diesem Gerät gespeichert. Sie werden gesendet, sobald du wieder Netz hast.",
  /** Counts words, not answers (issue #47). */
  firstTry: (n: number, words: number) =>
    `${n} von ${words === 1 ? "1 Wort" : `${words} Wörtern`} auf Anhieb richtig`,
  /** Only shown when it is not zero: no «0 Wörter sitzen neu». */
  newlySitting: (n: number) => (n === 1 ? "1 Wort sitzt neu" : `${n} Wörter sitzen neu`),
  /** A number, nothing more (docs/UX.md §9). Shown from two days on. */
  streak: (n: number) => `${n} Tage in Folge`,
  dueTitle: (lang: string) => `Heute dran · ${lang}`,
  /** Nothing due any more: the weakest known words instead (issue #96). */
  extraTitle: (lang: string) => `Extra-Runde · ${lang}`,
  /** Several lists at once, the weakest words first (issue #101). */
  reviewTitle: (lang: string) => `Wiederholen · ${lang}`,
  /**
   * End of round (issue #46). True, not a threat: a missed word sits in the
   * first box and is «heute dran» again tomorrow.
   */
  missedTitle: "Diese Wörter kommen bald wieder",
  speakWord: (word: string) => `«${word}» vorlesen`,
  again: "Nochmals",
  done: "Fertig",
  empty: "Keine Wörter zum Üben.",
  /** Offline, and this round was never kept on the device (issue #120). */
  notKept: "Ohne Netz kannst du nur üben, was auf dem Start zuoberst steht: «Heute dran» oder «Weiterüben».",
  /** Tiles for one typing card; counts like a second attempt (issue #63). */
  showTiles: "Kacheln zeigen",
  /**
   * Above the tiles after «Kacheln zeigen»: why the input went, and that it is
   * for this one word. No promise about the next card, which may be a new
   * word with tiles of its own (#97).
   */
  tilesHint: "Die Kacheln helfen nur bei diesem Wort.",
  matchHint: "Tippe ein Wort an und dann seinen Partner.",
  notYet: "Noch nicht.",
  matched: (prompt: string, answer: string) => `${prompt} — ${answer}. Richtig.`,
} as const;
